import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { outcomes } from '../data/content';
import { Reveal } from './Reveal';
export function Outcomes() {
  return <section className="bg-cream py-20 sm:py-28" aria-labelledby="resultados-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-179" data-mp="1hbkofzlsjljv">
      <div className="mx-auto max-w-6xl px-6" data-id="element-180" data-mp="1r6usstznw50t">
        <Reveal className="max-w-3xl" data-id="element-181" data-mp="1r5jp0u67ux9p">
          <h2 id="resultados-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-182" data-mp="tkx42euov3gf">
            Lo que vas a poder hacer desde el primer pedido
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-183" data-mp="13i1pudkmgwwp">
            Sin adivinar cantidades ni cobrar a ojo. Esto es lo que te deja listo el contenido de los tomos y los bonos.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-184" data-mp="asmgds8lvc2w">
          {outcomes.map((item, index) => <li key={item.title} className="flex" data-id="element-185" data-mp="frpbokysa3xo" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col rounded-2xl bg-sand p-7 ring-1 ring-inset ring-cream-line" data-id="element-186" data-mp="fqea8rst989q">
                <CheckCircle2Icon className="h-6 w-6 text-terra" aria-hidden="true" data-id="element-187" data-mp="2xzg5wz3amdds" />
                <h3 className="mt-4 font-display text-xl leading-snug text-ink" data-id="element-188" data-mp="2t76ns58f6hm2">
                  {item.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-189" data-mp="2p5lcgobjabdz">
                  {item.text}
                </p>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.04} data-id="element-190" data-mp="2f6vrgmoccati">
          <p className="mt-10 max-w-3xl text-sm leading-relaxed text-ink-muted" data-id="element-191" data-mp="2f6m291b4e7ov">
            Los precios de los menús y los ejemplos de costeo son referencias que muestran cómo se hace la cuenta. Tus ventas y tu ganancia dependen de tu zona, tus precios, tu tiempo y tus clientes.
          </p>
        </Reveal>
      </div>
    </section>;
}